import { Component, OnInit } from '@angular/core';
import { WindowService } from '../service/window.service';
import firebase from 'firebase';
import { environment } from '../../environments/environment';
import { Router, NavigationExtras } from '@angular/router';
import { ElectService } from '../service/elect.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  windowRef: any;
  phoneNumber: any;
  verificationCode: string;
  user: any;
  name: string = '';

constructor(private win: WindowService, public router: Router, private elsrv: ElectService) { 
//	firebase.initializeApp(environment.firebaseConfig);

}

  ngOnInit() {
    this.windowRef = this.win.windowRef
    this.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
    	size: 'invisible'
    })
    this.windowRef.recaptchaVerifier.render();
  }

sendLoginCode() {
    const appVerifier = this.windowRef.recaptchaVerifier;
    const aw = this.phoneNumber;
    const num = "+91" + aw;
    console.log(num)
    firebase.auth().signInWithPhoneNumber(num, appVerifier)
    .then(result => {
      this.windowRef.confirmationResult = result;
    })
    .catch( error => console.log(error) );

  }
  verifyLoginCode() {
    this.windowRef.confirmationResult
      .confirm(this.verificationCode)
      .then( result => {
        this.user = result.user;
        this.elsrv.getVoter(result.user.phoneNumber).subscribe(data => {
          if(data.length == 1){
            this.router.navigate(['/compartment'], { queryParams: { key: result.user.phoneNumber, uid: result.user.uid }, skipLocationChange: false });
          }else{
            this.router.navigate(['/unregvoter'], {queryParams: {stat: 'noreg'}});
          }
        });
    })
    .catch( error => alert("Invalid OTP"));
  }

}
